<router-outlet></router-outlet>


<div *ngIf="this.isLoading" style="z-index: 100000;position: fixed; top: 0;left: 0;width: 100%; height: 100%;  opacity: 70%" class="spinner-wrapper" role="status">
  <span class="spinner">Loading...</span>
</div>
<app-spinner></app-spinner>
